import type { SVGProps } from "react";
export interface StickerEmojiIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function StickerEmojiIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: StickerEmojiIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.876 20.75v-2.73a6.12 6.12 0 0 1-3.559-2.072l-.216-.271-.065-.095a1.126 1.126 0 0 1 1.79-1.345l.073.088.138.173a3.87 3.87 0 0 0 2.026 1.262 4.13 4.13 0 0 1 3.938-2.886h5.749l.116.006a1.126 1.126 0 0 1 0 2.239l-.116.005H15c-1.035 0-1.874.84-1.874 1.876v3.75a1.125 1.125 0 0 1-2.25 0M15 9.127a.62.62 0 0 0-.127.373l.014.125a.6.6 0 0 0 .113.247zm.998.745a.6.6 0 0 0 .113-.247l.014-.125-.014-.126A.6.6 0 0 0 16 9.127v.745Zm-6.887-.498A.6.6 0 0 0 9 9.129v.741a.6.6 0 0 0 .112-.245l.013-.125zM8 9.129a.62.62 0 0 0-.125.37l.012.126A.6.6 0 0 0 8 9.87zm2.126.37a1.625 1.625 0 0 1-3.242.167L6.875 9.5l.009-.166A1.625 1.625 0 0 1 8.5 7.875l.166.009c.82.083 1.46.774 1.46 1.616Zm6.999 0a1.625 1.625 0 0 1-3.242.167l-.007-.166.007-.166a1.626 1.626 0 0 1 3.242.166Z"
      />
      <path
        fill={color}
        d="M19.875 6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h5.613l8.262-6.426zm2.25 7.51c0 .574-.232 1.12-.637 1.518l-.183.161-8.344 6.488c-.373.29-.831.448-1.304.448H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
    </svg>
  );
}
